import axios from 'axios';
import _tools from "@/framework/common/qds_tools";
import { Message, Loading } from 'element-ui';
let info = _tools.getCookie('QDS_LOGIN_INFO_OFFICE');
info = info && JSON.parse(decodeURIComponent(info));
let platform = sessionStorage.getItem('source');
let source = window.location.href.indexOf('source=') > -1 ? window.location.href.split('source=')[1] : 1;
console.log(window.location.href);
let requestParams = {
	userId: info.userId || "6c7057467444384f346944576968664b582b486436513d3d",
	userIde: info.userId || "6c7057467444384f346944576968664b582b486436513d3d",
	identityIde: info.userId || "6c7057467444384f346944576968664b582b486436513d3d",
	platform: platform ? platform : source,
	appKey: "quandashi9838616927",
	timestamp: new Date().getTime(),
	format: "json",
	h5Query: 0,
	signMethod: "md5",
	executor: info.userId || "6c7057467444384f346944576968664b582b486436513d3d",
	sign: new Date().getTime() + '' + Math.floor((Math.random() * 10000) + 1),
	v: "1.0",
}
axios.defaults.baseURL = process.env.API_ROOT;
axios.defaults.timeout = 30000;
let loadingInstance = null
if(_tools.getCookie('qds_version_id') == 'v2') axios.defaults.headers.common['qds_version_id'] = 'v2' // 灰度测试用
axios.interceptors.request.use((config) => {
	if (!config.data.closeLoading) {
		loadingInstance = Loading.service({
			text: '加载中...',
		})
	}
	config.data.timestamp = new Date().getTime();
	config.data.sign = new Date().getTime() + '' + Math.floor((Math.random() * 10000) + 1)
	config.data = { ...requestParams, ...config.data }
	return config;
}, (error) => {
	return Promise.reject(error);
});

axios.interceptors.response.use((res) => {
	if (loadingInstance) {
		loadingInstance.close()
	}
	// if (res.data.code == 9091 && res.data.subCode == 10002) {
	// 	return res.data;
	// } else {
	// 	Message.error(res.data.subMessage);
	// }
	return res
}, (error) => {
	if (error.message.includes('timeout')) {
		Message.error("网络超时,请稍后重试");
	}
	return Promise.reject(error);
});

export default axios;



// WEBPACK FOOTER //
// ./src/axios.js